import { getContentByRef } from './get-content-by-ref.js';

/**
 * Get the root of the page in version v1.0
 *
 * @param pageModel
 * @param refPrefix - The custom prefix for refs (e.g., '&')
 * @returns the root of the page -
 * Note: Using discriminator function in order to verify isComponent(pageRootComponent)
 * returns false
 * because of that cast to a Record<string, any> to avoid TypeScript errors
 */ const getPageRoot = (pageModel, refPrefix)=>{
    if (!pageModel) {
        return undefined;
    }
    if (!pageModel.root) {
        return undefined;
    }
    const pageReferenceRef = pageModel.root.$ref;
    const pageRootComponent = getContentByRef(pageReferenceRef, pageModel, refPrefix);
    return pageRootComponent;
};

export { getPageRoot };
//# sourceMappingURL=get-page-root.js.map
